import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Logo = ({ className = "" }) => {
  const { t } = useLanguage();

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <div className="logo-sparkle relative inline-block">
        <img
          src="/probawin-logo.webp"
          alt="ProbaWins logo"
          className="h-14 sm:h-16 w-auto object-contain select-none logo-img"
          draggable={false}
        />
        {/* Sparkle dots */}
        <span className="sparkle sparkle-1" />
        <span className="sparkle sparkle-2" />
        <span className="sparkle sparkle-3" />
        <span className="sparkle sparkle-4" />
      </div>
      <div className="flex flex-col leading-tight">
        <span className="text-lg font-bold text-current">ProbaWins</span>
        <span className="text-[10px] font-medium -mt-0.5 opacity-60">
          {t.logo?.tagline || 'Jouez malin'}
        </span>
      </div>
    </div>
  );
};

export default Logo;
